export default {
  loadListError: 'Load error, please click to try again',
  finished: 'No more content',
  loading: 'Loading...',
  openAppMarketInfo: `Are you sure to open App Market?`,
  settings: 'Settings',
  linkRedirect: "You're about to open a link that leads to an external site. Please be mindful of your personal information and online safety.",
  cancel: 'Cancel',
  continue: 'Continue'
}